import React from 'react';
import Link from "gatsby-link";
import menu from '../../scripts/menu.js';
import styles from './header.module.scss';

import icon from '../../img/svg/logo-icon.svg';


class Header extends React.Component {

  componentDidMount () {
    menu();
  }

  render () {
    return (
      <div className={styles.globalHeader}>
        <h1 className={styles.logo}><img className={styles.icon} src={icon} alt=""/>CustomFIT</h1>
        <div id={'global-nav-toggle'} className={styles.menuToggle}><span></span><span></span><span></span></div>
        <nav id={'global-nav'}>
          <ul>
            <li className={'global-nav-close-toggle'} ><a id={'global-nav-close-toggle'} href="#">Close Menu</a></li>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/testimonials">Clients</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>
      </div>
    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/index.js